import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import FloatingContactWidget from './components/FloatingContactWidget';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import NDATemplate from './pages/NDATemplate';
import RefundPolicy from './pages/RefundPolicy';
import Disclaimer from './pages/Disclaimer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/nda-template" element={<NDATemplate />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
        <FloatingContactWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;